<template>
  <div>
    <div class="w-100 align-right mt-3 mb-3">
       <input
        type="text"
        v-model="search"
        style="width: 380px; height: 35px; border-radius: 5px; border: 1px solid #ccc;"
        placeholder="Número de ticket, cliente, repartidor o estatus"
        class="filter"
      /> 
      <el-button type="primary" plain icon="el-icon-delete-solid" class="ml-3" @click="clearFilter"></el-button>
    </div>

    <div class="flex-container">
      <div class="flex-row">
        <el-table
          ref="filterTable"
          :data="tableData.filter(
            data => !search || String(data.ticket_number).includes(search) || data.customer.name.toLowerCase().includes(search.toLowerCase()) || data.deliveryman_name.toLowerCase().includes(search.toLowerCase()) || data.status.toLowerCase().includes(search.toLowerCase()))"
          style="width: 100%"
          :header-cell-style="{textAlign: 'center', fontFamily: 'amaranth', fontSize: '16px', color:'#40b4e5'}"
          :cell-style="cellStyle"
          border
          emptyText="Cargando tickets activos, por favor espere un momento."
          
        >
        <el-table-column
            prop="created_at"
            label="Fecha"
            :min-width="95"
            align="center"
        />
          <el-table-column
            prop="ticket_number"
            label="Ticket"
            :min-width="100"
            align="center"
          >
           <template slot-scope="scope">
              <span><a href="#" @click.prevent="handleTicketDialog(scope.row.ticket)">{{ scope.row.ticket_number }} </a></span>
            </template>
          </el-table-column>

          <el-table-column
            prop="customer.name"
            label="Cliente"
            :min-width="300"
            align="left"
          />
          <el-table-column
            prop="customer.address.streetDistrict"
            label="Domicilio"
            :min-width="480"
            align="left"
          />
          <el-table-column
            prop="deliveryman_name"
            label="Repartidor"
            :min-width="300"
            align="left"
          >
            <template slot-scope="scope"> 
              <div v-if="scope.row.deliveryman_name" class="delivererName">
              <div class="col-6">
              <span>
                {{scope.row.deliveryman_name}}
              </span>
              </div>
              <div class="col-6" v-if="scope.row.current_status !== 'cancelled'">
                <el-dropdown class="menu" @command="assignDeliveryman">
                  <el-button size="small">
                    <i class="el-icon-edit el-icon--center"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown" :class="scope.row.dropdownMenu">
                    <el-dropdown-item v-for="deliveryman in deliverymen" :key="deliveryman.uuid" :command="composeValue(scope.row.number, deliveryman.uuid)">{{deliveryman.name}}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              </div>   
            </template>
          </el-table-column>

          <el-table-column
            prop="items.length"
            label="Productos"
            :min-width="100"
            align="center"
            style="{fontFamily: 'IBM Plex Mono', fontSize: '14px', color:'#465656'}"
          />
          <el-table-column
            prop="total"
            label="Total"
            :min-width="120"
            align="right"
          />
          <el-table-column
            prop="status"
            label="Estatus"
            :min-width="150"
            align="center"

          >
            <template slot-scope="scope">
              <div :class="scope.row.current_status">
                <el-tag>
                {{ scope.row.status }}
                </el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            :min-width="150"
            align="center"
            label="Detalles"
          >
            <template slot-scope="scope">
              <div style="display: flex">
              <el-button
                size="small"
                type="primary"
                plain
                icon="el-icon-view"
                @click="handleDetails(scope.$index, scope.row)"
              >
                Ver
              </el-button>
               <el-button
                v-if="scope.row.current_status !== 'cancelled'"
                size="small"
                type="danger"
                plain
                icon="el-icon-delete-solid"
                @click="handleConfirmationModal(scope.row.number, scope.row.ticket_number)"
              >
              </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      
      <!--- Modals below -->
      <ticketInfo
        :showInfoDialog="showInfoDialog"
        :dialogData="dialogData"
        :dialogTitle="dialogTitle"
        ref="ticketInfo"
        v-on:close="closeDialog('infoDialog')"
        />
      
      <cancelTicketDialog
        :cancelDialogVisible="cancelDialogVisible"
        :cancelNumberTicket="cancelNumberTicket"
        :cancelText="cancelText"
        :tableData="tableData"
        v-on:close="closeDialog('cancelDialog')"
      />

      <ticket
        :ticketDialogVisible="ticketDialogVisible"
        :ticketCode="ticketCode"
        v-on:close="closeDialog('ticketDialog')"/>

      </div>
    </div>
  </div>
</template>

<script>

import { getTickets } from "@/api/tickets.js";
import { getDeliverymen, assignDeliveryman } from "@/api/deliverymen.js";
import ticket from '@/views/components/Dialogs/ticket.vue';
import ticketInfo  from "@/views/components/Dialogs/ticketInfo.vue";
import cancelTicketDialog  from "@/views/components/Dialogs/cancelTicket.vue";

export default {
  name: "Home",
  components: {
    ticket,
    ticketInfo,
    cancelTicketDialog
  },
  data() {
    return {
      search: "",
      status: "",
      tableData: [],
      deliverymen: [],
      emptyText: "No hay datos",
      showInfoDialog: false,
      dialogTitle: "Ticket #??",
      dialogData: {
        assignedTo: "",
        statusId: 0,
        created_at: "",
        customer: {
          name: "",
          address: "",
          phone: "",
        },
        items: [],
      },
      ticketDialogVisible: false,
      ticketCode: "",
      cancelDialogVisible: false,
      cancelText: "",
      cancelNumberTicket: 0,
      msg: "", 
      map: {
        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        zoom: 15,
        center: [],
        markers: []
      }
    };
  },

  created() {
    this.getDeliverymen();
    this.fillTable();
  },
  mounted() {
    window.setInterval(() => {
      this.getDeliverymen();
      this.fillTable();
    }, 50000);
  },
  methods: {
    getDeliverymen() {
      getDeliverymen()
        .then(deliverymen => {
          this.deliverymen = deliverymen;
        })
        .catch(error => {
          console.log(error);
        });
    },
    fillTable() {
      this.tableData = [];

      getTickets()
        .then( tickets  => {
          this.tableData = tickets;
        })
        .catch(error => {
          console.log(error);
        });
    },
    clearFilter() {
      this.search = "";
      this.fillTable();
    },
    composeValue(number,uuid){
      return {
        number: number,
        uuid: uuid
      }
    },
    assignDeliveryman(command){
      assignDeliveryman(command.number, command.uuid)
        .then(response => {
          var msgStatus = "";
  
          if(response.status == "success"){
            this.tableData.find(row => row.number == command.number).deliveryman_name = response.deliveryman_name;
  
            if(this.tableData.find(row => row.number == command.number).current_status == "pending"){
              this.tableData.find(row => row.number == command.number).current_status= "assigned";
              this.tableData.find(row => row.number == command.number).status= "Asignado";

            } 
            msgStatus = "success";
          } else {
            msgStatus = "error";
          }
        
          this.showMessage(response.message, response.status);

        })
        .catch(error => {
          console.log(error);
        });
    },
    cellStyle({row, column, rowIndex, columnIndex}) {
        if(column.property == 'total' || column.property == 'unit_price_formatted') {
          return {
            fontFamily: 'IBM Plex Mono, monospace',
            fontSize: '14px',
            color:'#465656'
          };
        } else {
          return {
            fontFamily: 'trebuc',
            fontSize: '15px',
            color:'#465656'
          };
        }
    },
    handleDetails(index, row) {
      this.showInfoDialog = true;
      this.dialogData = row;
      this.dialogTitle = "Ticket #" + row.ticket_number;
         
      // if( row.delivered ){
      //   let temp = row.deliveries[0].location;
      //   this.map.markers.push( { pos:  [temp.lat, temp.lon], text: "Lugar de entrega" } );
      // }
      this.dialogData.items.forEach((item) => {     
        item.unit_price_formatted = "$" + item.unit_price.toFixed(2);;    
        item.total = "$" + (item.unit_price * item.units).toFixed(2);
      });
      this.$refs.ticketInfo.mapInfo(this.dialogData);
      
    },
    handleConfirmationModal(number, ticket_number) {
      this.cancelDialogVisible = true;
      this.cancelText = "¿Quieres cancelar el ticket #" + ticket_number + "?";
      this.cancelNumberTicket = number;
      
    },
    handleTicketDialog(ticket){
      this.ticketDialogVisible = true;
      ticket= ticket.replace("<BR>             ","");
      ticket = ticket.replace("              <BR><BR><BR><BR><BR>" ,"");
      this.ticketCode = ticket;
     
    },
    closeDialog(value){
      if(value == "cancelDialog"){
        this.cancelDialogVisible = false;
      } else if(value == "infoDialog"){
        this.showInfoDialog = false;
      } else if(value == "ticketDialog"){
        this.ticketDialogVisible = false;
      }
    },
    showMessage(msg, type){
      this.$message({
        timeout: 50000,
        message: msg,
        type: type,
      });
    },
  }
};
</script>

<style scoped>
body html {
  margin: 0;
  padding: 0;
}
.flex-container {
  margin: 0 5% 0 2%;
  display: flex;
}

.flex-row {
  flex: 1;
}

.filter {
  color: #465656;
  border-radius: 5px;
  border: 1px solid gray;
  padding: 5px 10px;
}

.delivererName {
  display: flex;
}

.menu {
  display: flex;
  justify-content: right;
}

.el-button--primary {
  color: #40b4e5;
  background-color: #ecf5ff;
  border-color: #40b4e5;
  font-family: 'trebuc';
  font-size: 13px;
}

.el-button--primary.is-plain {
  color: #40b4e5;
}

.el-button--primary.is-plain:focus, .el-button--primary.is-plain:hover {
  background: #40b4e5;
  border-color: #40b4e5;
  color: #fff;
}

.el-dropdown-menu__item {
  width: 150px;
}

.pending .el-tag, .assigned .el-tag, .collecting .el-tag, .collected .el-tag, .delivered .el-tag, .cancelled .el-tag {
  font-family: 'trebuc';
  font-size: 15px;
  width: 118px;
  height: "33px";
}

.pending .el-tag {
  background-color: #F56C6C;
  border-color: #F56C6C;
  color: #FFFFFF;
}

.pendingDropdown .el-dropdown-menu__item:focus, .pendingDropdown .el-dropdown-menu__item:not(.is-disabled):hover {
  width: 150px;
  background-color: #F56C6C;
  color: #FFFFFF;
}

.assigned .el-tag {
  background-color: #409EFF;
  border-color: #409EFF;
  color: #FFFFFF;
}

.assignedDropdown .el-dropdown-menu__item:focus, .assignedDropdown .el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #409EFF;
  color: #FFFFFF;
}

.collecting .el-tag{
  background-color: #FB8C00;
  border-color: #FB8C00;
  color: #FFFFFF;
}

.collectingDropdown .el-dropdown-menu__item:focus, .collectingDropdown .el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #FB8C00;
  color: #FFFFFF;
}

.collected .el-tag{
  background-color: #FFEB3B;
  border-color: #FFEB3B;
  color: #000000;
}

.collectedDropdown .el-dropdown-menu__item:focus, .collectedDropdown .el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #FFEB3B;
  color: #000000;
}

.delivered .el-tag {
  background-color: #67C23A;
  border-color: #67C23A;
  color: #FFFFFF;
}

.deliveredDropdown .el-dropdown-menu__item:focus, .deliveredDropdown .el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #67C23A;
  color: #FFFFFF;
}

.cancelled .el-tag{
  background-color: #9E9E9E;
  border-color: #9E9E9E;
  color: #FFFFFF;
}

.cancelledDropdown .el-dropdown-menu__item:focus, .cancelledDropdown .el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #67C23A;
  color: #FFFFFF;
}

</style>
